'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-cd939937.js');
var errors_errorCodes = require('./errorCodes.js');

var AppError = /** @class */ (function (_super) {
    tslib_es6.__extends(AppError, _super);
    function AppError(errorCode, errorName, errorMessage, meta) {
        if (meta === void 0) { meta = {}; }
        var _this = _super.call(this, "" + (errorName ? errorName + ' - ' : '') + (errorMessage || '')) || this;
        _this.errCode = null;
        _this.errSource = null;
        _this.code = null;
        _this.source = null;
        _this.meta = null;
        _this.name = errorName;
        _this.message = errorMessage;
        _this.code = errorCode;
        _this.meta = meta || {};
        switch (errorCode) {
            case errors_errorCodes.ErrorCodes.AMS_ERR:
                _this.source = 'AMS';
                break;
            case errors_errorCodes.ErrorCodes.NET_ERR:
                _this.source = 'HTTP';
                break;
            case errors_errorCodes.ErrorCodes.AIS:
                _this.source = 'AIS';
                break;
            case errors_errorCodes.ErrorCodes.CDN_ERR:
                _this.source = 'CDN';
                break;
            case errors_errorCodes.ErrorCodes.PLAYER_ERR:
                _this.source = 'PLAYER';
                break;
            default:
                _this.source = 'JS';
                break;
        }
        _this.errSource = _this.source;
        _this.errCode = _this.code;
        return _this;
    }
    return AppError;
}(Error));

exports.AppError = AppError;
